import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getTopPerformingDaycare } from '../../../feature/dashboard/DashboardSlice'

function TopPerformingDaycares({ month, year }) {
    const dispatch = useDispatch()
    const { topPerformingDaycare } = useSelector((state) => state.dashboards)

    useEffect(() => { dispatch(getTopPerformingDaycare({ month, year })) }, [month, year])

    const list = Array.isArray(topPerformingDaycare) ? topPerformingDaycare : []
    const maxRevenue = Math.max(...list.map(d => d.revenue || 0), 1)

    return (
        <div style={{ background: '#fff', borderRadius: 12, padding: '20px 20px', border: '1px solid #f0f0f0', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', height: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <div style={{ fontSize: 16, fontWeight: 700, color: '#111' }}>Top Performing Daycares</div>
                <span style={{ fontSize: 13, color: '#6366f1', cursor: 'pointer', fontWeight: 500 }}>View all</span>
            </div>
            {list.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '32px 0', color: '#bbb' }}>
                    <div style={{ fontSize: 32, marginBottom: 8 }}>🏆</div>
                    <div style={{ fontSize: 13, fontWeight: 500 }}>No performance data for this period</div>
                </div>
            ) : (
                <div style={{ minHeight: "280px",maxHeight:"300px", overflowY: "auto", display: 'flex', flexDirection: 'column', gap: 14 }}>
                    {list.map((d, i) => {
                        const revenue = d.revenue || 0
                        const width = Math.round((revenue / maxRevenue) * 100)
                        return (
                            <div key={i}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 5 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <span style={{ fontSize: 12, color: '#aaa', fontWeight: 600, width: 14 }}>{d.rank || i + 1}</span>
                                        <span style={{ fontSize: 13, fontWeight: 600, color: '#111' }}>{d.daycareName || `Daycare ${i + 1}`}</span>
                                    </div>
                                    <span style={{ fontSize: 13, fontWeight: 700, color: '#111' }}>${revenue.toLocaleString()}</span>
                                </div>
                                <div style={{ height: 4, borderRadius: 4, background: '#f0f0f0', overflow: 'hidden' }}>
                                    <div style={{ width: `${width}%`, height: '100%', background: '#6366f1', borderRadius: 4 }} />
                                </div>
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

export default TopPerformingDaycares
